<template>
  <div class="tab-pane" id="dtab4" role="tabpanel">
    <div class="mb-3">
      <h3>Geräte</h3>
      <div class="switch">
        <label class="w-100"> Geräte anzeigen
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <p class="mt-3">Geräteliste</p>
      <div class="search-bar">
        <div class="form-group doc-search">
          <input type="text" class="form-control" placeholder="Geräte suchen">
          <img class="form-control-feedback search-img" src="@/assets/images/search.png" alt="search-icon">
        </div>
      </div>

      <div class="kwords">
        <span class="chip">Bagger</span>
        <span class="chip">Planierraupe</span>
        <span class="chip">Rotationsglätter</span>
        <span class="chip">Drehbohrgerät</span>
        <span class="chip">Vorderkipper</span>
        <span class="chip">Walzenzug</span>
        <span class="chip">Mörtelpumpe</span>
        <span class="chip">Betonsäge</span>
        <span class="chip">Radlader</span>
        <span class="chip">Bauaufzug</span>
        <span class="chip">Arbeitsbühne</span>
        <span class="chip">Betonmischer</span>

      </div>

      <p class="mt-3">Firmenliste</p>
      <div class="search-bar">
        <div class="form-group doc-search">
          <input type="text" class="form-control" placeholder="Firma suchen">
          <img class="form-control-feedback search-img" src="@/assets/images/search.png" alt="icon">
        </div>
      </div>

      <div class="kwords">
        <span class="chip">HSM Baumanagement</span>
        <span class="chip">projectdocu</span>
        <span class="chip">Otto Bau</span>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionEquipmentTab.vue